/**
 * CargaSaraiva
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {CargaSaraivaCollection} from '@/model/collection/CargaSaraivaCollection'

/* TODO: review generated class */
export class CargaSaraiva extends Resource {
  idCargaPk: number = 0

  dataCriacao: string | null = null
  ativo: boolean | null = null

  danfe: string | null = null
  notaFiscal: string | null = null
  nomeDestinatario: string | null = null
  documentoDestinatario: string | null = null
  enderecoDestinatario: string | null = null
  nomeTransportador: string | null = null

  get $id() {
    return this.idCargaPk
  }
  set $id(val) {
    this.idCargaPk = val
  }

  /**
   * Gets a instance of a given ID of CargaSaraiva
   */
  async getCargaSaraiva(id: number) {
    return await Request.get(`/admin/carga-saraiva/${id}`)
      .name('getCargaSaraiva')
      .as(this)
      .getData()
  }

  /**
   * Deletes a instance of a given ID of CargaSaraiva
   */
  async removeCargaSaraiva() {
    return await Request.delete(`/admin/carga-saraiva/${this.$id}`)
      .name('removeCargaSaraiva')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaSaraiva
   */
  static async listCargaSaraiva(params: any) {
    return await Request.get(`/admin/carga-saraiva`, {params})
      .name('listCargaSaraiva')
      .as(CargaSaraivaCollection)
      .getData()
  }

  /**
   * Persists a new instance of CargaSaraiva. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistCargaSaraiva() {
    return await Request.post(`/admin/carga-saraiva`, this)
      .name('persistCargaSaraiva')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of CargaSaraiva to use it in a CSV file
   */
  static async listCsvCargaSaraiva(params: any) {
    return await Request.get(`/admin/carga-saraiva/csv`, {params})
      .name('listCsvCargaSaraiva')
      .as(CargaSaraivaCollection)
      .getData()
  }
}
